module.exports = __webpack_public_path__ + "static/media/Garment_makers.516c7a32.jpg";